var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TabMenu',{attrs:{"tabs":_vm.tabsData},scopedSlots:_vm._u([{key:"tab-title",fn:function(tab){return [_c('div',{staticClass:"badge-color"},[_vm._v(" ("+_vm._s(tab.count)+") ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }